<template>
  <ModalVue
    :modal-active="modalActive"
    max-width="!max-w-[70vw]"
    has-footer-border
    has-header-border
    @close="handleClose"
  >
    <template #header>
      <h2 class="text-lg font-bold text-gray-900 text-left w-full">
        Salvar configuração como modelo
      </h2>
    </template>

    <div class="flex flex-col gap-4 p-4">
      <ApprovalFlowPreview :layers="layers" />

      <GenericInput
        v-model="templateName"
        label="Nome do modelo"
        hide-details="auto"
        data-testid="template-name-input"
      />

      <v-autocomplete
        v-model="selectedCompanyId"
        :items="listCompanies"
        label="Empresa"
        variant="outlined"
        density="comfortable"
        color="primary20"
        hide-details="auto"
        data-testid="company-select"
      />
    </div>

    <template #footer>
      <div class="flex gap-4 w-full">
        <div class="flex-1">
          <OutlineButton
            text="Cancelar"
            width="100%"
            :disabled="loading"
            data-testid="cancel-save-template-button"
            @click="handleClose"
          />
        </div>
        <div class="flex-1">
          <FilledButton
            text="Salvar"
            width="100%"
            :disabled="!canSave || loading"
            :loading="loading"
            data-testid="confirm-save-template-button"
            class="bg-primary30"
            @click="handleSave"
          />
        </div>
      </div>
    </template>
  </ModalVue>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import ApprovalFlowPreview from '@/components/ManageScale/Schedule/ApprovalFlowPreview.vue'
import GenericInput from '@/components/designSystem/Inputs/GenericInput.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import { useCompanyStore } from '@/pinia-store/useCompanyStore'
import type { ApprovalLayerDetail } from '@/Network/Types/Responses/ApprovalFlowResponses'

const props = defineProps<{
  modalActive: boolean
  layers: ApprovalLayerDetail[]
  loading?: boolean
}>()

const emit = defineEmits<{
  (e: 'close'): void
  (e: 'save', payload: { name: string; companyId: number }): void
}>()

const companyStore = useCompanyStore()
const { listCompanies } = storeToRefs(companyStore)

const templateName = ref('')
const selectedCompanyId = ref<string | null>(null)

const canSave = computed(() => {
  return templateName.value.trim().length > 0 && selectedCompanyId.value !== null
})

const resetState = () => {
  templateName.value = ''
  selectedCompanyId.value = null
}

const handleClose = () => {
  if (props.loading) return
  resetState()
  emit('close')
}

const handleSave = () => {
  if (!canSave.value || props.loading) return

  emit('save', {
    name: templateName.value.trim(),
    companyId: Number(selectedCompanyId.value)
  })
}

onMounted(() => {
  if (listCompanies.value.length === 0) {
    companyStore.getMyCompanies()
  }
})
</script>
